import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { withRouter } from "../../../providers/withRouter";
import { DataTable, ProgressBarWithColors } from "../../../components";
import { desvincularProveedor, desvincularProveedorDeFincas, formatoFechasEs } from "../../../functions/funciones";
import {

  Box,
  Tooltip,
  Typography,

} from "@mui/material";
import { getAaffListSuplier, getAllTecnicos, getFincasUnAAFF, getOneAAFF, getSuppliersListPropertie } from "../../../services";
import BreadCrumb from "../../../components/navbar/Breadcrumb";

import { UsuarioContext } from "../../../providers/userContext";
import FiltrosProveedores from "../../../components/filtros/filtrosProveedores";
import Desvincular from "../../../icons/desvincular.svg";
import Warning from "../../../icons/warning.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';
import { IoSync } from "react-icons/io5";

const ProveedoresLista = (props) => {
  const { t } = useTranslation('suppliers');
  const [aaff, setAAFF] = useState([]);
  const {filtrosIniciales, filtroOrder} = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(false);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  
  const navigate = useNavigate();
  const [primeraCarga, setPrimeraCarga] = useState(true);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });

  const loadAAFF = async () => {
    const af = await getOneAAFF(props.params.nif)
    setAAFF(af)
  }

  useEffect(() => {
    if (!aaff.id) {
      loadAAFF();
    }
    if (aaff.id) {
      fetchData();
    }
  }, [recargar, aaff]);

  const user = useContext(UsuarioContext);
  
    const clearFilters = () => {
      
      if (user.rol === "CONSUL" && primeraCarga) {
        setBusqueda({
          ...busqueda,
          consul_id: user.id 
        });
        setPrimeraCarga(false);
      }
      else{
        setBusqueda({});
      }
      
      setClearFilterActivo(true);
    }

  const fetchData = async ({ offset, limit, filtros = busqueda,order,orderBy } = {}) => {

    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order =   order || filtroOrder.orden || 'ASC';

    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy);

    if (!aaff.id) {
    return;
  }

    const payload = {
      filtros:{ ...filtros, aaff_id: aaff.id },
      // filtros:{...filtros, aaff_id: 3},
      params: { page: offset, limit, order,orderBy },
    };

    try {
      setLoading(true);
      const response = await getAaffListSuplier(payload);
      const { meta, data } = response;

      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handledesvincularCallback = () => {
setRecargar(!recargar);
  };

  const desvincularProvs = async (idProv) => {
    const fincas = await getFincasUnAAFF({aaff_id: aaff.id})
    const fincaIds = fincas.map(finca => finca.id);
    desvincularProveedorDeFincas(fincaIds, idProv, aaff.id).then((resultado) => {
      handledesvincularCallback(resultado)
    })
  }

  
  const formatData = (data) => {
    return data.map((row) => (
      console.log(row),
      {
      nif: row.nif,
      createdAt: row.ultimaReclamacion === null ? row.createdAt : row.ultimaReclamacion,
      razonSocial: row.razonSocial,
      municipio: row.municipio,
      provincia: row.provincia,
      cumplimiento: row.porcentajeDocs,
      desvincular: <img
        src={Desvincular}
        alt="Desvincular"
        className="tableIcon"
        onClick={() => desvincularProvs(row.id)}
      ></img>,
      docsPendientes: row.hasPendingDocs,
      // nuevosSuppsTaaf: row.newSuppsLastWeekTaaf,
      source: row.source,
    }));
  };
  const filtrarDatos = (filtros) => {
    setBusqueda(filtros)
    setBusquedaActiva(true);
    // fetchData({ offset: 1, limit: limite, filtros: { ...filtros, aaff_id: aaff.id } });
  }

  const proveedoresRows = [

    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.supplier'),
      overrideFunc: (data, row) =>
      (
        <Link to={"/aaff/"+props.params.nif+"/proveedores/" + row.nif}>
          {data}
        </Link>
      )
    },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: false,
      label: t('columns.lastReclamation'),
      overrideFunc: (data) => data ? formatoFechasEs(data) : '',
    },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('columns.municipality'),
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('columns.province'),
    },
    {
      id: "cumplimiento",
      numeric: false,
      disablePadding: false,
      label: t('columns.compliance'),
      noObjeto:true,
      overrideFunc: (row) => (
        <ProgressBarWithColors
          value={row}
          label={
            <Typography>
              {row}
            </Typography>
          }
        />
      ),
    },
    {
      id: "docsPendientes",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto:true,
      overrideFunc: (row) => (
        <>
          {row === true ?
            <img src={Warning} width={15} alt="pendientes" />
            : null}
        </>
      ),
    },
    // {
    //   id: "nuevosSuppsTaaf",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "SYNC",
    //   noObjeto: true,
    //   overrideFunc: (data, row) => (
    //     <div style={{ display: 'flex' }}>
    //       {row.nuevosSuppsTaaf > 0 ?
    //         <Tooltip title={`Proveedor nuevo de taaf en la última semana`} arrow>
    //           <div>
    //             <IoSync style={{ fontSize: '2rem' }} />
    //           </div>
    //         </Tooltip>
    //       : null
    //       }
    //     </div>
    //   ),
    // },
    {
      id: "source",
      numeric: false,
      disablePadding: false,
      label: t('columns.source'),
      noObjeto: true,
    },
    {
      id: "desvincular",
      numeric: false,
      disablePadding: false,
      label: t('columns.unlink'),
      noObjeto:true,
    },
  ]

  return (
    <>
      <BreadCrumb rutas={[{ path: '/aaff', label: t('aaff:title') }, { path: `/aaff/${aaff.nif}/comunidades`, label: `${aaff.razonSocial}` }, { path: `/aaff/${aaff.nif}/proveedores`, label: t('title') }]} style={{ margin: '0 10px' }} />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">{t('list').toUpperCase()}</div>
          <div className="tableContainer">
            <div style={{ display: "flex" }}>
              <FiltrosProveedores onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda}/>
              {/* <div className="exportar">
                <ExportarProveedoresLista busqueda={Resbusqueda} /> 
              </div> */}
            </div>
            <div className="tableWrapper">
              <Box className="pageContent">
                <Box sx={{ mb: 10 }}>
                  <DataTable
                    data={data.rows}
                    isLoading={loading}
                    headers={proveedoresRows}
                    fetcher={fetchData}
                    currentPage={data.current_page}
                    meta={data.meta}
                    totalItems={data.total}
                    totalPages={data.totalPages}
                    nextPage={data.next_page}
                    filtros={busqueda}
                    busquedaActiva={busquedaActiva}
                    setBusquedaActiva={setBusquedaActiva}
                    clearFilterActivo={clearFilterActivo}
                    setClearFilterActivo={setClearFilterActivo}
                    mensaje={t('noSuppliers')}
                    enumerate={true}
                  />
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(ProveedoresLista);
